export default "/images/vendor/flag-icon-css/flags/1x1/im.svg?3b9ec59891d962581ef833673449af7b";